import { DataAttributesProps, EditableControlComponentProps, NumEditComponentProps } from "@multiweb/reactComponents";
import { OWDataType } from "@multiweb/types/contracts";
import { ControlUtils } from "../../UI/UI/Controls/ControlUtils";
import { EditableControlConnector } from "../EditableControlConnector";
import { GenericControlConnectorAttrs } from "../GenericControlConnector";

/**
 * Umožňuje napojení NumEdit react komponenty do původní multiweb aplikace.
 * Rozšiřuje {@link EditableControlConnector} a obsahuje navíc atributy specifické pro {@link NumEditComponentProps}.
 */
export class NumEditConnector extends EditableControlConnector {
    /** Omezuje horní limit číselné hodnoty atributu. Hodnota se získává z elementu a jeho atributu `maxvalue`, kde ho je možné zapsat i exponenciálně. */
    private _maxValue?: number;

    /** Omezuje dolní limit číselné hodnoty atributu. Hodnota se získává z elementu a jeho atributu `minvalue`, kde ho je možné zapsat i exponenciálně. */
    private _minValue?: number;

    /** Formátovací řetězec pro zobrazení hodnot čísel, datumů, bool hodnot a dalších */
    private _displayFormat?: string;

    constructor(attrs: GenericControlConnectorAttrs, canRender: boolean = false) {
        super(attrs, canRender);

        this._maxValue = ControlUtils.getNumDataAttr("maxvalue", this.element);
        this._minValue = ControlUtils.getNumDataAttr("minvalue", this.element);
        this._displayFormat = ControlUtils.getDataAttr("displayformat", this.element);

        this._render();
    }

    public override get dataType(): OWDataType | string {
        return super.dataType;
    }

    public override set dataType(dataType: OWDataType | string) {
        const prevDataType = this.dataType;

        super.dataType = dataType;

        if (prevDataType !== this.dataType) {
            this._render();
        }
    }

    public get maxValue(): number | undefined {
        return this._maxValue;
    }

    public set maxValue(maxValue: number) {
        const prevMaxValue = this._maxValue;
        this._maxValue = maxValue;

        if (prevMaxValue !== this._maxValue) {
            this._render();
        }
    }

    public get minValue(): number | undefined {
        return this._minValue;
    }

    public set minValue(minValue: number) {
        const prevMinValue = this._minValue;
        this._minValue = minValue;

        if (prevMinValue !== this._minValue) {
            this._render();
        }
    }

    public get displayFormat(): string {
        return this._displayFormat;
    }

    public set displayFormat(displayFormat: string) {
        this._displayFormat = displayFormat;

        this._render();
    }

    protected override _getRenderProps(): NumEditComponentProps & EditableControlComponentProps & DataAttributesProps {
        return {
            ...super._getRenderProps(),
            displayFormat: this.displayFormat,
            maxValue: this.maxValue,
            minValue: this.minValue,
            dataType: this.dataType,
        };
    }
}
